

























































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import ExampleForm from '@/views/Form/ExampleForm.vue'

@Component({
    components: {
        ExampleForm,
    },
})
export default class EditEmmaChatForm extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>

    @Prop({ required: true }) readonly company: Company
}
